import { Grid, Switch } from "antd";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";

/**
 * Grid araç çubuğunda yenile düğmesinin yanındaki anahtarlar: Bakiyesi Mevcut + Silinenleri Dahil Et.
 * Silinenler kapalıyken yalnız silinmemişler (isDeleted=false), açıkken hepsi (isDeleted=null).
 * Filtre formunun dışında durdukları için değişiklik doğrudan uygulanan filtreye yazılır;
 * AppointmentFilter formu bu alanları gizli tutar ve updateKey ile eşitlenir.
 */
export default function AppointmentGridToggles() {
    const { queryModel, onFilterPageSort } = useDataGrid();
    const { hasPermission } = useUser();
    // Mobilde kısa etiketler: yenile + iki anahtar + (hakediş) İşlemler menüsü tek satıra sığsın
    const short = Grid.useBreakpoint().md === false;
    const filter = queryModel.filter || {};

    const apply = (changes) => onFilterPageSort({ filter: { ...filter, ...changes } });

    // false/undefined → yalnız silinmemişler; null (hepsi) ya da eski linkten gelen true → açık.
    const includeDeleted = filter.isDeleted !== undefined && filter.isDeleted !== false;

    return (
        <div className="appt-grid-toggles">
            <label className="appt-grid-toggles__switch">
                <Switch
                    size="small"
                    checked={!!filter.hasBalance}
                    onChange={(checked) => apply({ hasBalance: checked })}
                />
                <span>{short ? t('Balance Short') : t('Has Balance')}</span>
            </label>

            {hasPermission(PERMISSIONS.APPOINTMENT_VIEW_DELETE) && (
                <label className="appt-grid-toggles__switch">
                    <Switch
                        size="small"
                        checked={includeDeleted}
                        onChange={(checked) => apply({ isDeleted: checked ? null : false })}
                    />
                    <span>{short ? t('Deleted Short') : t('Include Deleted')}</span>
                </label>
            )}
        </div>
    );
}
